import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {PartialGameDomainModel} from "../../../domain/partial-game/models/partial-game-domain-model";
import {CompetitionDomainModel} from "../../../domain/common/competition/models/competition-domain-model";
import {SportDomainModel} from "../../../domain/sports/models/sport-domain-model";
import {CountryDomainModel} from "../../../domain/common/country/models/country-domain-model";
import {
  GameCompetitorDomainModel
} from "../../../domain/partial-game/models/game-competitor/game-competitor-domain-model";
import {WebsiteModuleState} from "../../../apps/website/models/website-module.state";
import {ACTION_TYPES, SESSION_STORAGE_KEYS} from "../../../core/consts";
import {GameCenterWidgetState} from "../models/game-center-widget.state";
import {SessionStorageUtils} from "../../../infrastructure/utils/session-storage.utils";
import {FullGamePopulateDataHandler} from "../../../core/handlers/full-game.populate-data.handler";
import {NAVIGATION_TABS} from "../../../modules/navigation-tabs-module/navigation-tabs-module.consts";

export class GameCenterWidgetPopulateDataHandler extends FullGamePopulateDataHandler {
  websiteModuleState: WebsiteModuleState;
  sessionStorageUtils: SessionStorageUtils;
  state: GameCenterWidgetState;

  static injectables = [...PopulateDataHandler.injectables, WebsiteModuleState, SessionStorageUtils];

  constructor(websiteModuleState: WebsiteModuleState, sessionStorageUtils: SessionStorageUtils) {
    super();

    this.websiteModuleState = websiteModuleState;
    this.sessionStorageUtils = sessionStorageUtils;
  }

  onLoaded(controller: BaseController) {
    super.onLoaded(controller);

    this.handleGameCenterTabIndexChange(this.appStore.state.context.tabIndex)
  }

  handleGameCenterTabIndexChange(tabIndex) {
    const index: Number = tabIndex || this.controller.props.location?.state?.tabIndex || 0;

    this.controller.action(ACTION_TYPES.tabChange, {index})
  }

  async action(params) {
    if (!params || !params.dataSource) {
      return;
    }

    if (!params.dataSource.apiModel && params.dataSource.game) {
      const sportDomainModel: SportDomainModel = new SportDomainModel(params.dataSource.game.sport.apiModel);
      const countryDomainModel: CountryDomainModel = new CountryDomainModel(params.dataSource.game.competition.country.apiModel);
      const competitionDomainModel:CompetitionDomainModel = new CompetitionDomainModel(params.dataSource.game.competition.apiModel, countryDomainModel, sportDomainModel);

      const homeCompetitorCountryDomainModel: CountryDomainModel = new CountryDomainModel(params.dataSource.game.homeCompetitor.country.apiModel);
      const awayCompetitorCountryDomainModel: CountryDomainModel = new CountryDomainModel(params.dataSource.game.awayCompetitor.country.apiModel);
      const homeCompetitorDomainModel: GameCompetitorDomainModel = new GameCompetitorDomainModel(params.dataSource.game.homeCompetitor.apiModel, homeCompetitorCountryDomainModel, sportDomainModel);
      const awayCompetitorDomainModel: GameCompetitorDomainModel = new GameCompetitorDomainModel(params.dataSource.game.awayCompetitor.apiModel, awayCompetitorCountryDomainModel, sportDomainModel);

      const partialGameDomainModel: PartialGameDomainModel =
        new PartialGameDomainModel(
          params.dataSource.game.apiModel,
          competitionDomainModel,
          homeCompetitorDomainModel,
          awayCompetitorDomainModel,
          params.dataSource.game.startTime,
          sportDomainModel,
        )

      params.dataSource.game = partialGameDomainModel;
    }

    if (params.dataSource.game?.eventChartPenaltiesDetails?.uniqueHashEvent) {
      const responseUniqueHashEvent = params.dataSource.game?.eventChartPenaltiesDetails?.uniqueHashEvent;
      const currentLivePenalties = this.sessionStorageUtils.get(`${SESSION_STORAGE_KEYS.livePenalties}_${responseUniqueHashEvent}`);
      if (!currentLivePenalties) {
        const responseUniqueHashEvent = params.dataSource.game?.eventChartPenaltiesDetails?.uniqueHashEvent;
        this.sessionStorageUtils.set(`${SESSION_STORAGE_KEYS.livePenalties}_${responseUniqueHashEvent}`, true);
        this.state.shouldRenderLivePenaltiesPopup = true;
      }
    } else {
      this.state.shouldRenderLivePenaltiesPopup = false;
    }
    await super.action(params);
    this.websiteModuleState.entitiesContext.setGame(params.dataSource.game);

  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const nextIndex: Number = nextProps.location?.state?.tabIndex || this.controller.state.appState.context.tabIndex;
    const isTabIndexChanged: Boolean = this.state.currentIndex !== nextIndex;
    const isGameIdChange: Boolean = prevProps.location?.state?.id !== nextProps.location?.state?.id;

    if (isTabIndexChanged || isGameIdChange) {
      const index: Number = nextIndex || NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.match;

      this.controller.action(ACTION_TYPES.tabChange, {index})
    }
  }
}
